export const transformData = (payload) => {
  if (payload['record_label_affiliation']) {
    let proAffiliation = { value: payload['record_label_affiliation'].pk, label: payload['record_label_affiliation'].name + ` (${payload['record_label_affiliation'].pk})` }
    payload['record_label_affiliation'] = proAffiliation
  }
  return payload
}
